export enum DocumentCompletionStatus {
  CreatedNotStarted = 'createdNotStarted',
  InProgress = 'inProgress',
  Completed = 'completed',
}
